import React from 'react';

export default function LoadingSpinner() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '60vh', background: '#0a1628',
    }}>
      <div style={{
        width: 44, height: 44, border: '3px solid rgba(0,194,255,0.15)',
        borderTopColor: '#00c2ff', borderRadius: '50%', animation: 'spin 0.8s linear infinite',
      }} />
    </div>
  );
}
